import moment, { Moment } from 'moment'
import { dateCommon } from 'src/constants';

export const formatDate = (date: Moment, format: string = dateCommon): string => (date ? date.format(format) : '')
export const dateTo = (date: Moment): string => (date ? date.format('DD MMMM YYYY') : '')
export const getFullStamp = (string: Moment): string => (string ? string.format('YYYY-MM-DD HH:mm') : '')
export const reformatDate = (date: Date, format: string) : Moment => {
	return moment( date, format)
}
